'use strict'

import angular from 'angular'

import buySheetComplexFieldsListComponentHtmlUrl from './buySheetComplexFieldsList.component.html'

angular.module('buySheet.components').component('buySheetComplexFieldsList', {
    templateUrl: buySheetComplexFieldsListComponentHtmlUrl,
    bindings: {
        entities: '<',
        entitiesType: '<',
        entitiesTablesHeaders: '<',
        subEntitiesType: '<'
    },
    controllerAs: 'vm'
})